module.exports = __webpack_public_path__ + "img/东美奥拉克.8c08cb5.png";